import { apiRequest } from '../api/ApiRequest';

// import { jsonDateParser } from "json-date-parser";



const UPDATE_CLAIM_STORY = 'claimtracker/UPDATE_CLAIM_STORY';
const UPDATE_USER_SENDING_IN = 'claimtracker/UPDATE_USER_SENDING_IN';
const UPDATE_PACKAGE_LIST = 'claimtracker/UPDATE_PACKAGE_LIST';
const UPDATE_BATCH_RECORD_REGISTERED_LIST = 'claimtracker/UPDATE_BATCH_RECORD_REGISTERED_LIST';
const UPDATE_BATCH_RECORD_DEREGISTERED_LIST = 'claimtracker/UPDATE_BATCH_RECORD_DEREGISTERED_LIST';
const UPDATE_CLAIM_RECORD_LIST = 'claimtracker/UPDATE_CLAIM_RECORD_LIST';
const UPDATE_ERROR_RECORD_LIST = 'claimtracker/UPDATE_ERROR_RECORD_LIST';
const UPDATE_CLAIMINFO = 'claimtracker/UPDATE_CLAIMINFO';



const UPDATE_CLAIMNUMBER = 'claimtracker/UPDATE_CLAIMNUMBER';

const UPDATE_CLAIMNUMBER_USAGE_LIST = 'claimtracker/UPDATE_CLAIMNUMBER_USAGE_LIST';


const BASE_URL = process.env.REACT_APP_DEBTDEFAULT_API_URL + '/tracker';


export const loadClaimStory = claimID => async dispatch => {
  // dispatch({ type: LOADING_CALCULATION_PACKAGE });
  const data = await apiRequest(`${BASE_URL}/claimstory/${claimID}`);
  if (!data.error) {
    console.debug("loadClaimStory", claimID, data);

    dispatch({
      type: UPDATE_CLAIM_STORY,
      data: data || []
    });
  }
  // dispatch({ type: LOADED_CALCULATION_PACKAGE });
  return data;
};


export const loadUserSendingInList = () => async dispatch => {
  // dispatch({ type: LOADING_CALCULATION_PACKAGE });
  const data = await apiRequest(`${BASE_URL}/whoaresendingbatches`);
  if (!data.error) {
    dispatch({
      type: UPDATE_USER_SENDING_IN,
      data: data || []
    });
  }
  // dispatch({ type: LOADED_CALCULATION_PACKAGE });
  return data;
};


export const loadUserSentPackageList = (userID) => async dispatch => {
  // dispatch({ type: LOADING_CALCULATION_PACKAGE });
  const data = await apiRequest(`${BASE_URL}/recivedbatches/${userID}`);
  if (!data.error) {
    dispatch({
      type: UPDATE_PACKAGE_LIST,
      data: data || []
    });
  }
  // dispatch({ type: LOADED_CALCULATION_PACKAGE });
  return data;
};


export const loadRecordList = (batchID, recordAction) => async dispatch => {
  // dispatch({ type: LOADING_CALCULATION_PACKAGE });
  const data = await apiRequest(`${BASE_URL}/recordsinbatch/${batchID}/${recordAction}`);
  if (!data.error) {
    if (recordAction === 1) {
      dispatch({
        type: UPDATE_BATCH_RECORD_REGISTERED_LIST,
        data: data || []
      });
    }
    else {
      dispatch({
        type: UPDATE_BATCH_RECORD_DEREGISTERED_LIST,
        data: data || []
      });
    }
  }
  // dispatch({ type: LOADED_CALCULATION_PACKAGE });
  return data;
};

export const loadRecordError = (trackID) => async dispatch => {
  // dispatch({ type: LOADING_CALCULATION_PACKAGE });
  const data = await apiRequest(`${BASE_URL}/erroronrecord/${trackID}`);
  if (!data.error) {
    dispatch({
      type: UPDATE_ERROR_RECORD_LIST,
      data: data || []
    });
  }
  // dispatch({ type: LOADED_CALCULATION_PACKAGE });
  return data;
};

export const loadClaimNumberRecords = (claimnumber) => async dispatch => {
  // dispatch({ type: LOADING_CALCULATION_PACKAGE });
  const data = await apiRequest(`${BASE_URL}/claimnumber/${claimnumber}`);
  if (!data.error) {
    dispatch({
      type: UPDATE_CLAIMNUMBER_USAGE_LIST,
      data: data || []
    });
  }
  // dispatch({ type: LOADED_CALCULATION_PACKAGE });
  return data;
};



export const loadClaimInfo = (claimID) => async dispatch => {
  // dispatch({ type: LOADING_CALCULATION_PACKAGE });
  const data = await apiRequest(`${BASE_URL}/claiminfo/${claimID}`);
  if (!data.error) {
    dispatch({
      type: UPDATE_CLAIMINFO,
      data: data || []
    });
  }
  // dispatch({ type: LOADED_CALCULATION_PACKAGE });
  return data;
};


export const updateClaimNumber = claimNumber => async dispatch => {
  dispatch({
    type: UPDATE_CLAIMNUMBER,
    data: claimNumber
  });
  dispatch(loadClaimNumberRecords(claimNumber));
};




const initialState = {
  claimStoryList: [],
  userSendingInList : [],
  packageList : [],
  registerRecordList : [],
  deRegisterRecordList : [],
  claimNumberRecordList : [],
  errorRecordList : [],
  claimNumber : undefined,
  claimInfo : undefined
};


export default (state = initialState, action) => {
  if (action.data === null) {
    return state;
  }
  switch (action.type) {
    case UPDATE_CLAIM_STORY: {
      return {
        ...state,
        claimStoryList: action.data
      };
    }
    case UPDATE_USER_SENDING_IN: {
      return {
        ...state,
        userSendingInList: action.data
      };
    }
    case UPDATE_PACKAGE_LIST: {
    return {
      ...state,
      packageList: action.data
    };
    }
    case UPDATE_BATCH_RECORD_REGISTERED_LIST: {
      return {
        ...state,
        registerRecordList: action.data
      };
    }
    case UPDATE_BATCH_RECORD_DEREGISTERED_LIST: {
      return {
        ...state,
        deRegisterRecordList: action.data
      };
    }
    case UPDATE_CLAIMNUMBER_USAGE_LIST: {
      return {
        ...state,
        claimNumberRecordList: action.data
      };
    }
    case UPDATE_ERROR_RECORD_LIST: {
      return {
        ...state,
        errorRecordList: action.data
      };
    }
    case UPDATE_CLAIMNUMBER: {
      return {
        ...state,
        claimNumber: action.data
      };
    }
    case UPDATE_CLAIMINFO: {
      return {
        ...state,
        claimInfo: action.data
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/ducks/claimtracker.js